import { render, staticRenderFns } from "./404Error.vue?vue&type=template&id=0850fa0d&scoped=true&functional=true&"
import script from "./404Error.vue?vue&type=script&lang=js&"
export * from "./404Error.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "0850fa0d",
  null
  
)

export default component.exports